var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgIconRequirementSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#15D8A0",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.692 7.566a1 1 0 1 0-1.384 1.443l2.097 2.013a1 1 0 0 0 1.462-.083l3.902-4.7a1 1 0 1 0-1.538-1.278L7.015 8.835z"
}))));
export { SvgImgIconRequirementSuccess as ReactComponent };
export default __webpack_public_path__ + "img/img-icon-requirement-success.664f6ee2b08af7d301f14b9e93e0765e.svg";